import { useMemo, useState } from 'react'

import { ms } from 'utils/time/millisecond'

type PageSizeToCacheLengthItem = [
  // pageSize:
  number,
  // cache length:
  number
]
type PageSizeToCacheLengthStrategy = PageSizeToCacheLengthItem[]

export const defaultPagedQueryScalingStrategy: PageSizeToCacheLengthStrategy = [
  // if there's only one page, we only need one api call, so don't bother caching
  [1, 0],
  // 5 pages is 100 records or less, so cache it for a few minutes
  [5, ms.minutes(2)],
  // 5 minutes is the max we cache the data
  [Infinity, ms.minutes(5)]
]

// this is something conceptual I'm trying out here
// as the number of pages of data increase/decrease we track how many there are
// and we return different caching values based on that
// so for larger data sets we'll keep the data around longer and refresh less frequently
export function usePagedQueryScaledCaching(
  strategy = defaultPagedQueryScalingStrategy
) {
  const [numPages, setNumPages] = useState(0)

  const cacheTTL = useMemo(() => {
    const [, ttl] = strategy.find(([pageSize]) => numPages <= pageSize) ?? [
      Infinity,
      0
    ]
    return ttl
  }, [numPages, strategy])

  return {
    cacheTTL,
    setNumPages
  }
}
